// Laguna Benefits — tunable constants (frontend mirror of backend).
// Single source of truth for numbers that may change after compliance review.
//
// Phase 2a: anchor figures now derived from real MassMutual rates (source:
// massmutual_2026_tripeaks_v1). To refresh after a new rate table drops,
// re-run `backend/scripts/ingest_mm_rates.py` and eyeball that the anchor
// row (age 35 / $50K / non-tobacco) matches the numbers below.

// Conservative guaranteed growth rate used for projecting cash value at ages 75 and 85.
// PENDING MASSMUTUAL COMPLIANCE APPROVAL — change this one value when finalized.
export const PROJECTED_GROWTH_RATE = 0.03;

// Ages on the horizon toggle.
export const HORIZON_AGES = [65, 75, 85];

// Share limits.
export const SHARE_MAX_FRIEND_RECIPIENTS = 5;
export const SHARE_MAX_PEER_RECIPIENTS = 3;

// Quote-form minimum.
export const MIN_EMPLOYEE_COUNT = 10;

// Support / Ask-Mark destination.
export const ASK_MARK_EMAIL = "support@lagunabenefits.life";

// --- /how-it-works simulator -------------------------------------------------
// Timing (verbatim from the prototype).
export const HOW_IT_WORKS_FRAME_DURATION_MS = 4500;
export const HOW_IT_WORKS_INITIAL_DELAY_MS = 800;
export const SIMULATOR_HANDOFF_ON_HOVER = true;

// Anchor: age 35, $50K coverage, non-tobacco. Real MassMutual TriPeaks rates.
export const PREMIUM_BIWEEKLY = 27.26;
export const YEAR_1_PAID = 708.76;
export const YEAR_10_PAID = 7087.6;
// Conservative dividend projection at the 10-year mark. NOT guaranteed —
// used alongside the guaranteed-at-65 figure for a dual-horizon story.
export const YEAR_10_CASH_VALUE = 3890;
// MassMutual's *published* guaranteed cash value for the anchor row —
// guaranteed at age 65 (the milestone the MM proposal reports against).
// Source: massmutual_2026_tripeaks_v1.
export const GUARANTEED_CV_AT_AGE_65 = 18102;
// Kept as alias for any lingering imports.
export const GUARANTEED_CV_AT_MILESTONE = GUARANTEED_CV_AT_AGE_65;
export const DEATH_BENEFIT = 50000;


// --- Phase 3c — Auth entry-point hardening ----------------------------------

// Magic-link /sent screen "Send again" cooldown. Independent of the server
// rate limit; this is UI-only discipline to prevent accidental double-taps.
export const MAGIC_LINK_RESEND_COUNTDOWN_SECONDS = 30;

// Success Team Calendly — consolidated single source of truth. Replaces
// three hardcoded variants (`/laguna-benefits`, `/laguna-benefits/support`,
// `/laguna-success`) that had accumulated across PortalEmployee,
// PortalProposal, TeamApply, and PortalChrome.
export const CALENDLY_SUCCESS_TEAM_URL = "https://calendly.com/laguna-benefits";
